<template>
    <div>
        <v-card v-bind="cardProps" class="fill-height d-flex flex-column">
            <v-card-title
                :style="{ backgroundColor: titleBgColor, color: titleDarkText ? 'black' : 'white', titleStyle }"
                :class="titleClass"
            >
                <slot name="title"> </slot>
            </v-card-title>

            <div style="flex-grow: 1">
                <slot name="body"></slot>
            </div>
        </v-card>
    </div>
</template>
<script>
export default {
    props: {
        titleBgColor: {
            type: String,
            default: '#ff530d',
        },
        titleDarkText: {
            type: Boolean,
            default: false,
        },
        cardProps: {
            typs: Object,
            default: () => {},
        },
        titleClass: {
            type: [String, Array, Object],
            default: '',
        },
        titleStyle: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style lang=""></style>
